import List from '@mui/material/List';
import { Box } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import { changeOption } from '../../store/slices/function/sideBar-filterTabSlice';
import React, { useEffect } from 'react';
import { backOfficeSideBarValues } from '../../data/nav/backNav';
import { SideBarButtonBackOffice } from './backoffice/SideBarButton';

function SideBarBackOffice(): React.JSX.Element {
  const dispatch = useDispatch();
  const sideBarIndex = useSelector((state: RootState) => state.sideBar);

  const handleUrlPick = () => {
    let initialOption: number = 0;
    for (let i = 0; i < backOfficeSideBarValues.length; i++) {
      if (backOfficeSideBarValues[i].link === window.location.pathname)
        initialOption = backOfficeSideBarValues[i].option;
    }
    dispatch(
      changeOption({
        option: initialOption,
        name: window.location.pathname,
        drawerOpen: false,
      }),
    );
  };

  useEffect(() => {
    handleUrlPick();
  }, []);

  return (
    <Box height='100%'>
      <Box
        position='relative'
        sx={{ boxShadow: '1', zIndex: '1250 !important', height: '110vh' }}
      >
        <Grid container>
          <Grid xs={12}>
            <List
              sx={{
                overflow: 'hidden',
                paddingBlockStart: '66px',
                position: 'sticky',
                top: '0px',
              }}
            >
              <Grid
                container
                spacing={1}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                }}
              >
                {backOfficeSideBarValues.map((item, index) => {
                  return (
                    <Grid
                      xs={12}
                      key={index}
                    >
                      <SideBarButtonBackOffice item={item} />
                    </Grid>
                  );
                })}
              </Grid>
            </List>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default SideBarBackOffice;
